import ReportTable from '../../../../../components/Grid/ReportTable';

export default function OperacoesTable(props: any) {
  return <ReportTable model={props.model} columnCount={16} />;
}
